import { FORNECEDORES_API_URL } from '../../constants/urls';

import xlsx from 'json-as-xlsx';
import { Parser } from 'json2csv';
// export PDF
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import {
  valuePromotion,
  default_first_buy_coupon,
} from 'src/constants/promotion';

export const getPromotionMessage = ({
  link,
  firstBuyCoupon = default_first_buy_coupon,
}) => {
  const message = `Garanta agora R$${valuePromotion} de desconto, frete reduzido e acesso a milhares de produtos usando o cupom ${firstBuyCoupon}. O desconto é válido para a primeira compra na Inventa, comprando acima de R$600. Acesse as vantagens pelo link exclusivo:`;

  return `${message} ${link}`;
};

export const formatDataEnvio = date => {
  const data = date;
  let dataFormatada = '-';
  if (data) {
    const dateObj = new Date(`${data}T00:00:00-03:00`);
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const dayFormatted = day < 10 ? `0${day}` : day;
    const monthFormatted = month < 10 ? `0${month}` : month;
    dataFormatada = `${dayFormatted}/${monthFormatted}/${year}`;
  }
  return dataFormatada;
};

export const formatDate = timestamp => {
  const dateObj = new Date(timestamp);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const dayFormatted = day < 10 ? `0${day}` : day;
  const monthFormatted = month < 10 ? `0${month}` : month;
  const dataFormatada = `${dayFormatted}/${monthFormatted}/${year}`;
  return dataFormatada;
};

export const formatDataRepasse = data => {
  if (
    data.status_finance_raw &&
    (data.status_finance_raw === 'OLD_CONSOLIDATION' ||
      data.status_finance_raw === 'OLD_CONSOLIDATION_PAID')
  ) {
    if (data.data_pagamento_fornecedor) {
      // console.log(e.data_pagamento_fornecedor)
      return formatDate(data.data_pagamento_fornecedor);
    }
    return ' - ';
  }
  // Resolver com um regex, todos que tiverem _PAID no nome

  if (
    (data.status_finance_raw === 'FRAUD_ALERT_PAID' &&
      data.timestamp_payment_formatted) ||
    (data.status_finance_raw === 'OPS_CANCEL_PAID' &&
      data.timestamp_payment_formatted) ||
    (data.status_finance_raw === 'OLD_CONSOLIDATION_PAID' &&
      data.timestamp_payment_formatted) ||
    (data.status_finance_raw === 'CANCELAMENTO_PAID' &&
      data.timestamp_payment_formatted) ||
    (data.status_finance_raw === 'PO_ARCHIVADA_PAID' &&
      data.timestamp_payment_formatted) ||
    (data.status_finance_raw === 'INCOMPLETE_DOCUMENTS' &&
      data.timestamp_payment_formatted) ||
    (data.status_finance_raw === 'COMPLETE' && data.timestamp_payment_formatted)
  ) {
    return data.timestamp_payment_formatted;
  }
  return ' - ';
};

export const cleanInput = (setState, ref) => {
  if (typeof setState === 'function') setState('');
  if (typeof ref === 'string') {
    const input = document.querySelector(ref);
    if (input) input.value = '';
  }
};

export const cleanInputByRef = ref => {
  if (typeof ref === 'string') {
    const input = document.querySelector(ref);
    if (input) input.value = '';
  }
};

export const clickElement = ref => {
  if (typeof ref === 'string') {
    const e = document.querySelector(ref);
    if (e) e.click();
  }
};

export const getFileType_fileName = filename => {
  if (typeof filename === 'string') {
    const a = filename.split('.');
    return a[a.length - 1];
  }
  return null;
};

export const formatCPF = value =>
  value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada

export const formatCNPJ = value =>
  value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, '$1.$2.$3/$4-$5');

export const formatDateDeCalendar = timestamp => {
  const dateObj = new Date(timestamp);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const dayFormatted = day < 10 ? `0${day}` : day;
  const monthFormatted = month < 10 ? `0${month}` : month;
  const dataFormatada = `${year}-${monthFormatted}-${dayFormatted}`;

  return dataFormatada;
};

export const formatDeliveryDate = date => {
  const dateObj = new Date(`${date}T00:00:01`);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;
  const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;

  return formattedDate;
};

export const formatDatePromotion = timestamp => {
  const dateObj = new Date(timestamp);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate() + 1;
  const year = dateObj.getFullYear();
  const dayFormatted = day < 10 ? `0${day}` : day;
  const monthFormatted = month < 10 ? `0${month}` : month;
  const dataFormatada = `${dayFormatted}/${monthFormatted}/${year}`;

  return dataFormatada;
};

export const formatPrice = number =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(number);

export const formatNumber = number =>
  new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 0,
  }).format(number);

export const downloadPublicFile = (url, filename) => {
  fetch(url)
    .then(res => res.blob())
    .then(res => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([res]));
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentElement.removeChild(link);
    })
    .catch(res => {
      console.error(res);
    });
};

export const renewTimestamp_url = url => {
  if (typeof url === 'string') {
    try {
      const a = new URLSearchParams(url);
      a.set('v', new Date().getTime());
    } catch (err) {
      console.error(err);
    }
  }
};

export const formatImage = (imageUrl, sizeImage) => {
  const getUrlImage = imageUrl.split('.');

  getUrlImage[getUrlImage.length - 2] += sizeImage;
  const newUrl = getUrlImage.join('.');

  return newUrl;
};

export const switchVariantStatus = (productID, variantID, action, token) => {
  if (productID && variantID && action && token) {
    fetch(
      `${FORNECEDORES_API_URL}/product/product/${productID}/variant/${variantID}/${action}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      },
    )
      .then(res => {
        console.log(`Status: ${res.status}`);
        return res.json();
      })
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        console.log(err);
      });
  } else {
    throw new Error('Missing data');
  }
};

export const getTagValue = (tags, key) => {
  if (typeof tags === 'string' && typeof key === 'string') {
    const a = tags.split(',');
    const b = a.find(e => e.toLowerCase().includes(key.toLowerCase()));
    if (b) {
      const value = b.toLowerCase().split(key.toLowerCase());
      const c = value[value.length - 1];
      if (c) return c;
    } else return null;
  }
  return null;
};

export const returnBussinessDays = (date, daysToReturn) => {
  try {
    const dateObj = new Date(`${date}T00:00:01`);

    if (
      !Number.isNaN(dateObj.getTime()) &&
      !Number.isNaN(parseInt(daysToReturn, 10))
    ) {
      for (let i = daysToReturn; i > 0; i--) {
        do {
          dateObj.setDate(dateObj.getDate() + 1);
        } while (dateObj.getDay() === 0 || dateObj.getDay() === 6);
      }
      return dateObj.getTime();
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

// TODO: refact it
export const dataTableSortFunction = (data, columns, direction) => {
  const { key } = columns;
  const a = data.sort((a, b) => {
    let comparison = 0;
    switch (key) {
      case 'id':
        const idA = a.Lojista_Order.name
          ? a.Lojista_Order.name.substring(1)
          : 0;
        const idB = b.Lojista_Order.name
          ? b.Lojista_Order.name.substring(1)
          : 0;
        if (idA > idB) comparison = 1;
        else if (idB > idA) comparison = -1;
        break;
      case 'order_date':
        const dateA = new Date(a.Order_Date || a.created_at);
        const dateB = new Date(b.Order_Date || b.created_at);
        if (dateA.getTime() > dateB.getTime()) comparison = 1;
        else if (dateB.getTime() > dateA.getTime()) comparison = -1;
        break;
      case 'value':
        const order_valueA = a.Total ? parseFloat(a.Total) : 0;
        const order_valueB = b.Total ? parseFloat(b.Total) : 0;
        if (order_valueA > order_valueB) comparison = 1;
        else if (order_valueB > order_valueA) comparison = -1;
        break;
      case 'value_status':
        const valueA = a.Pagamento_Fornecedor
          ? a.Pagamento_Fornecedor
          : 'Pendente';
        const valueB = b.Pagamento_Fornecedor
          ? b.Pagamento_Fornecedor
          : 'Pendente';
        if (valueB === 'Pendente' && valueA !== 'Pendente') comparison = 1;
        else if (valueA === 'Pendente' && valueB !== 'Pendente')
          comparison = -1;
        else if (valueA === 'Sim' && valueB !== 'Sim') comparison = 1;
        else if (valueB === 'Sim' && valueA !== 'Sim') comparison = -1;
        break;
    }
    return direction === 'desc' ? comparison * -1 : comparison;
  });
  return a;
};

// TODO: refact it
export const dataTableSortFunctionExtrato = (data, columns, direction) => {
  const { key } = columns;
  const a = data.sort((a, b) => {
    let comparison = 0;
    switch (key) {
      case 'id':
        const idA = a.Lojista_Order.name
          ? a.Lojista_Order.name.substring(1)
          : 0;
        const idB = b.Lojista_Order.name
          ? b.Lojista_Order.name.substring(1)
          : 0;
        if (idA > idB) comparison = 1;
        else if (idB > idA) comparison = -1;
        break;
      case 'order_date':
        const dateA = new Date(a.order_date || a.created_at);
        const dateB = new Date(b.order_date || b.created_at);
        if (dateA.getTime() > dateB.getTime()) comparison = 1;
        else if (dateB.getTime() > dateA.getTime()) comparison = -1;
        break;
      case 'value':
        const order_valueA = a.Total ? parseFloat(a.Total) : 0;
        const order_valueB = b.Total ? parseFloat(b.Total) : 0;
        if (order_valueA > order_valueB) comparison = 1;
        else if (order_valueB > order_valueA) comparison = -1;
        break;
      case 'value_status':
        const valueA = a.Pagamento_Fornecedor
          ? a.Pagamento_Fornecedor
          : 'Pendente';
        const valueB = b.Pagamento_Fornecedor
          ? b.Pagamento_Fornecedor
          : 'Pendente';
        if (valueB === 'Pendente' && valueA !== 'Pendente') comparison = 1;
        else if (valueA === 'Pendente' && valueB !== 'Pendente')
          comparison = -1;
        else if (valueA === 'Sim' && valueB !== 'Sim') comparison = 1;
        else if (valueB === 'Sim' && valueA !== 'Sim') comparison = -1;
        break;
    }
    return direction === 'desc' ? comparison * -1 : comparison;
  });
  return a;
};

export const extratoDataTableSort = (data, columns, direction) => {
  const { key } = columns;
  const newData = data.sort((a, b) => {
    let comparison = 0;
    if (key === 'id') {
      const caseA = a.order_name ? a.order_name.substring(1) : 0;
      const caseB = b.order_name ? b.order_name.substring(1) : 0;

      if (caseA > caseB) comparison = 1;
      else if (caseB > caseA) comparison = -1;
    }
    if (key === 'data_de_envio') {
      const dateA = new Date(a.data_de_envio || a.created_at);
      const dateB = new Date(b.data_de_envio || b.created_at);

      if (dateA.getTime() > dateB.getTime()) comparison = 1;
      else if (dateB.getTime() > dateA.getTime()) comparison = -1;
    }
    return direction === 'desc' ? comparison * -1 : comparison;
  });
  return newData;
};

export const transportOptions = list => {
  if (Array.isArray(list)) {
    const a = list.sort((a, b) => {
      const nameA = a.alias || a.name;
      const nameB = b.alias || b.name;
      if (nameA.toLowerCase() > nameB.toLowerCase()) return 1;
      if (nameA.toLowerCase() < nameB.toLowerCase()) return -1;
      return 0;
    });
    return a.map((e, i) => (
      <option key={e.uuid ? e.uuid : `trans-${i}`} value={e.alias || e.name}>
        {e.alias || e.name}
      </option>
    ));
  }
  return null;
};

export const docColor = number => {
  let cor = number.toString();

  if (number === '8/8') {
    cor = 'confirmado-card';
  } else {
    cor = 'reject-card';
  }

  return cor;
};

export const countDocs = pedido => {
  const arrayNomeDocs = [
    'CTe_FP',
    'Danfe_FP',
    'ICMS_ST',
    'NF_FP',
    'Tracking_Number',
    'Data_de_Envio',
    'Custo_de_Envio_FP',
    'Transportadora',
  ];
  let count = 0;
  arrayNomeDocs.forEach(field => {
    if (pedido[field] && pedido[field].length) count += 1;
  });
  return `${count}/${arrayNomeDocs.length}`;
};

export const capitalizeFirstLetter = sentence => {
  let splitSentence = sentence.split(' ').map(word => word.toLowerCase());
  splitSentence = splitSentence.map(
    word => word.charAt(0).toUpperCase() + word.substring(1),
  );
  return splitSentence.join(' ');
};

export const filterPedidos = (pedidos, fields) => {
  const { search, status, from, to } = fields;
  if (pedidos && Array.isArray(pedidos)) {
    const dateFrom = from ? new Date(from) : false;
    const dateTo = to ? new Date(to) : false;
    if (dateTo) dateTo.setDate(dateTo.getDate() + 1);
    const statusObj = status
      ? {
          type: status.split(':')[0],
          value: status.split(':')[1],
        }
      : false;

    const orders = pedidos.filter(item => {
      const cliente = item.Lojista ? item.Lojista.name : '';
      const orderDate = new Date(item.Order_Date);
      const valor_formatted = formatPrice(item.Total).substring(3);
      if (statusObj) {
        if (
          statusObj.type === 'SO' &&
          statusObj.value !== item.Status_Fornecedores_Portal
        )
          return false;
        if (statusObj.type === 'SR') {
          const payment_status =
            item.Pagamento_Fornecedor && item.Pagamento_Fornecedor === 'Sim'
              ? 'Realizada'
              : item.Pagamento_Fornecedor === 'Não'
              ? 'Rejeitada'
              : 'Pendente';
          if (payment_status !== statusObj.value) return false;
        }
      }
      if (
        search &&
        search.length &&
        !(
          search === item.Lojista_Order.name.includes(search) ||
          item.Lojista_Order.name
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          valor_formatted.includes(search) ||
          cliente.includes(search) ||
          cliente.toLowerCase().includes(search.toLowerCase()) ||
          item.cnpj.includes(search)
        )
      )
        return false;
      if (dateFrom && dateFrom > orderDate) return false;
      if (dateTo && dateTo < orderDate) return false;

      return true;
    });
    return orders;
  }
  return null;
};

export const filterExtrato = (pedidos, fields) => {
  const { search, status } = fields;
  if (pedidos && Array.isArray(pedidos)) {
    // const dateFrom = from ? new Date(from) : false;
    // const dateTo = to ? new Date(to) : false;
    // if (dateTo) dateTo.setDate(dateTo.getDate() + 1);
    const statusObj = status
      ? {
          type: status.split(':')[0],
          value: status.split(':')[1],
        }
      : false;

    const orders = pedidos.filter(item => {
      const cliente = item.order_name ? item.order_name : '';
      // let orderDate = new Date(item.Order_Date);
      const valor_formatted = formatPrice(item.Total).substring(3);
      if (statusObj) {
        if (
          statusObj.type === 'SO' &&
          statusObj.value !== item.status_fornecedores_portal
        )
          return false;
        if (statusObj.type === 'SR') {
          const payment_status =
            item.Pagamento_Fornecedor && item.Pagamento_Fornecedor === 'Sim'
              ? 'Realizada'
              : item.Pagamento_Fornecedor === 'Não'
              ? 'Rejeitada'
              : 'Pendente';
          if (payment_status !== statusObj.value) return false;
        }
      }
      if (
        search &&
        search.length &&
        !(
          search === item.order_name.includes(search) ||
          item.order_name.toLowerCase().includes(search.toLowerCase()) ||
          valor_formatted.includes(search) ||
          cliente.includes(search) ||
          cliente.toLowerCase().includes(search.toLowerCase())
        )
      )
        return false;
      // if (dateFrom && dateFrom > orderDate) return false;
      // if (dateTo && dateTo < orderDate) return false;

      return true;
    });
    return orders;
  }

  return null;
};

export const filterProducts = (produtos, fields) => {
  const { search, status } = fields;
  if (produtos && Array.isArray(produtos)) {
    const products = produtos.filter(item => {
      const sku = item.variants[0].sku.split('|')[0];
      const preco_original = getTagValue(item.tags, 'PRECO ORIGINAL:');
      const preco_original_formatted = formatPrice(preco_original).substring(3);

      if (status) {
        if (status !== item.status) return false;
      }

      if (search) {
        if (
          search === item.name?.includes(search) ||
          item.name?.toLowerCase().includes(search.toLowerCase())
        ) {
          return true;
        }
        if (
          search === sku?.includes(search) ||
          sku?.toLowerCase().includes(search.toLowerCase())
        ) {
          return true;
        }
        if (item.tags && preco_original) {
          if (
            search === preco_original_formatted?.includes(search) ||
            preco_original_formatted
              ?.toLowerCase()
              .includes(search.toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        if (
          search === item.full_price?.includes(search) ||
          item.full_price?.toLowerCase().includes(search.toLowerCase())
        ) {
          return true;
        }
        return false;
      }

      return true;
    });
    return products;
  }

  return null;
};

export const dateToISOFormat = date => {
  if (date) {
    const date_obj = new Date(date);
    if (Number.isNaN(date_obj.getTime())) return null;

    const date_string = date_obj.toISOString(date_obj);
    const hours = date_obj.getHours();
    const mins = date_obj.getMinutes();
    const secs = date_obj.getSeconds();

    const timezone_string = `${date_string.split('T')[0]}T${
      hours === 0 ? '00' : hours < 10 ? `0${hours}` : hours
    }:${mins === 0 ? '00' : mins < 10 ? `0${mins}` : mins}:${
      secs === 0 ? '00' : secs < 10 ? '0' : `${secs}`
    }-03:00`;
    return timezone_string;
  }
  return null;
};
export const handleCopy = async (
  selector,
  trigger,
  messageAlert,
  timerId,
  setShowAlert,
) => {
  // every time I use setTimeOut, I save in a ref, the id of timeOut and every time it is used again I clean that id before firing another.
  if (timerId.current) {
    clearTimeout(timerId?.current);
  }

  if (selector) {
    const element = document.querySelector(selector);
    const urlLink = element.value;

    if (element) {
      element.select();
      document.execCommand('copy');
      await navigator.clipboard.writeText(urlLink);
      setShowAlert(prevState => ({
        ...prevState,
        variant: 'success',
        trigger,
        message: messageAlert,
      }));
      const id = setTimeout(() => {
        setShowAlert(prevState => ({
          ...prevState,
          variant: '',
          trigger: null,
          message: '',
        }));
      }, 3000);
      timerId.current = id;
    }
  }
};

export const handleDownloadFile = (url, nameAttribute) => {
  fetch(url)
    .then(res => {
      if (res.status === 200) {
        return res.blob();
      }
      throw Error('Access denied');
    })
    .then(response => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([response]));
      link.setAttribute('download', nameAttribute);
      document.body.appendChild(link);
      link.click();
      link.parentElement.removeChild(link);
    })
    .catch(err => {
      console.error('error on download file>>', err);
    });
};

/**
 * @coment Scroll to the element that refers to when clicking the buttons.
 *
 * @param {String} Selector Selector class HMTML
 * @param {Int} substractMargin
 * @return {void}
 */
export const handleScroll = (selector, substractMargin = 0) => {
  const elem = document.querySelector(selector);
  const rect = elem.getBoundingClientRect();
  window.scrollTo({
    top: rect.y - substractMargin,
    behavior: 'smooth',
  });
};

export const cnpjFormat = value =>
  value.replace(/(\d{2})?(\d{3})?(\d{3})?(\d{4})?(\d{2})/, '$1.$2.$3/$4-$5');

export const DicionarioStatus = {
  CANCELAMENTO: 'Cancelado',
  CANCELAMENTO_PAID: 'Realizado',
  COMPLETE: 'Agendado',
  INCOMPLETE_DATA_ENVIO: 'Documentos faltantes',
  INCOMPLETE_DOCUMENTS: 'Documentos faltantes',
  INCOMPLETE_LINE_ITEMS: 'Em revisão',
  INCOMPLETE_PAYMENT: 'Em revisão',
  FRAUD_ALERT: 'Em revisão',
  FRAUD_ALERT_PAID: 'Realizado',
  OLD_CONSOLIDATION: 'Em revisão',
  OLD_CONSOLIDATION_PAID: 'Realizado',
  ORDER_PAID: 'Realizado',
  OPS_CANCEL: 'Cancelado',
  OPS_CANCEL_PAID: 'Realizado',
  PO_ARCHIVADA: 'Em revisão',
  PO_ARCHIVADA_PAID: 'Realizado',
  DATA_DE_ENVIO_ERROR: 'Data de envio inválida',
};

export const exportCSV = filteredOrders => {
  const columnsMap = {
    'Nº do pedido': 'order_name',
    'Data de envio': 'data_de_envio',
    'Status do pedido': 'status_fornecedores_portal',
    'Valor dos produtos': 'sub_total',
    Comissão: 'take_rate',
    'ICMS-ST': 'icms_st',
    Frete: 'shipping',
    'Valor de repasse': 'total',
    'Status de repasse': 'status_finance_raw',
    'Data de repasse': 'real_payment_date_format',
  };

  const extratoTable = [];
  filteredOrders.forEach(data => {
    const aux = {};

    Object.keys(columnsMap).forEach(nome_coluna => {
      // formatacao de data
      if (columnsMap[nome_coluna].includes('data_de_envio')) {
        aux[nome_coluna] = formatDataEnvio(data[columnsMap[nome_coluna]]);
        return;
      }
      // Formatar valores
      if (
        columnsMap[nome_coluna].includes('total') ||
        columnsMap[nome_coluna].includes('_rate') ||
        columnsMap[nome_coluna].includes('_st') ||
        columnsMap[nome_coluna].includes('ajuste')
      ) {
        aux[nome_coluna] = formatPrice(data[columnsMap[nome_coluna]]);
        return;
      }
      // formatacao de dicionario
      if (columnsMap[nome_coluna].includes('_finance_raw')) {
        aux[nome_coluna] = DicionarioStatus[data[columnsMap[nome_coluna]]];
        return;
      }
      if (columnsMap[nome_coluna].includes('_date_format')) {
        if (data[columnsMap[nome_coluna]]) {
          aux[nome_coluna] = data[columnsMap[nome_coluna]];
          return;
        }
        if (!data[columnsMap[nome_coluna]]) {
          if (data.data_pagamento_fornecedor) {
            aux[nome_coluna] = formatDataEnvio(data.data_pagamento_fornecedor);
            return;
          }
          aux[nome_coluna] = '-';
          return;
        }
      }
      if (columnsMap[nome_coluna].includes('_pagamento_fornecedor')) {
        if (data[columnsMap[nome_coluna]]) {
          aux[nome_coluna] = data[columnsMap[nome_coluna]];
          return;
        }
        if (!data[columnsMap[nome_coluna]]) {
          if (data[columnsMap.data_pagamento_fornecedor]) {
            aux[nome_coluna] = data[columnsMap.data_pagamento_fornecedor];
            return;
          }
          aux[nome_coluna] = '-';
          return;
        }
      }
      // se houver # no id do pedido, entao precisa remover para fazer o csv
      if (columnsMap[nome_coluna].includes('order_name')) {
        aux[nome_coluna] = data[columnsMap[nome_coluna]].replace('#', '');
        return;
      }
      aux[nome_coluna] = data[columnsMap[nome_coluna]];
    });
    extratoTable.push(aux);
  });

  const json2csvParser = new Parser();
  const csv = `data:text/csv;charset=utf-8,\uFEFF${json2csvParser.parse(
    extratoTable,
  )}`;

  const encodedUri = encodeURI(csv);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `extrato_financeiro.csv`);
  document.body.appendChild(link); // Required for FF

  link.click();
};

export const exportPDF = (filteredOrders, multivendorName) => {
  const doc = new JsPDF('l', 'pt', 'a4');
  doc.setFontSize(20);
  doc.setFont('courier', 'normal');
  doc.text(
    `Inventa - ${multivendorName} - Extrato financeiro - ${formatDate(
      Date.now(),
    )}`,
    20,
    30,
  );
  doc.autoTable({
    styles: { fontSize: 8 },
    head: [
      [
        'Nº do pedido',
        'Data de envio',
        'Status do pedido',
        'Valor dos produtos',
        'Comissão',
        'ICMS-ST',
        'Frete',
        'Valor de repasse',
        'Status de repasse',
        'Data de repasse',
      ],
    ],
    body: filteredOrders.map(data => [
      data.order_name,
      formatDataEnvio(data.data_de_envio),
      data.status_fornecedores_portal ? data.status_fornecedores_portal : '-',
      formatPrice(data.sub_total),
      formatPrice(data.take_rate),
      formatPrice(data.icms_st),
      formatPrice(data.shipping),
      formatPrice(data.total),
      data.status_finance_raw
        ? DicionarioStatus[data.status_finance_raw]
        : 'Em revisão',
      data.data_pagamento_fornecedor
        ? data.data_pagamento_fornecedor.split('-').reverse().join('/')
        : data.real_payment_date_format
        ? data.real_payment_date_format
        : '-',
    ]),
  });
  doc.addPage('a4', 'l');
  doc.setFontSize(20);
  doc.setFont('courier', 'normal');
  doc.text(
    `Inventa - ${multivendorName} - Extrato financeiro - ${formatDate(
      Date.now(),
    )}`,
    20,
    30,
  );
  doc.setFont('courier', 'bold');
  doc.text('Entenda como o seu valor de repasse é calculado:', 20, 90);
  doc.setFont('courier', 'italic');
  doc.setTextColor(100);
  doc.text('Valor total dos produtos', 405, 140, null, null, 'center');
  doc.setTextColor(0);
  doc.setFont('courier', 'bold');
  doc.text('-', 405, 160, null, null, 'center');
  doc.setFont('courier', 'italic');
  doc.setTextColor(100);
  doc.text('Comissão', 405, 180, null, null, 'center');
  doc.setTextColor(0);
  doc.setFont('courier', 'bold');
  doc.text('+', 405, 200, null, null, 'center');
  doc.setFont('courier', 'italic');
  doc.setTextColor(100);
  doc.text('ICMS-ST', 405, 220, null, null, 'center');
  doc.setFont('courier', 'bold');
  doc.setTextColor(0);
  doc.text('+', 405, 240, null, null, 'center');
  doc.setFont('courier', 'italic');
  doc.setTextColor(100);
  doc.text('Frete', 405, 260, null, null, 'center');
  doc.setTextColor(0);
  doc.text('=', 405, 280, null, null, 'center');
  doc.setFont('courier', 'bold');
  doc.text('Valor de repasse', 405, 300, null, null, 'center');
  doc.save('extrato.pdf');
};

export const exportExcel = filteredOrders => {
  const data = [
    {
      sheet: 'Extrato Financeiro',
      columns: [
        { label: 'Nº do pedido', value: 'numeroPedido' },
        { label: 'Data de envio', value: 'dataPedido' },
        { label: 'Status do pedido', value: 'statusPedido' },
        { label: 'Valor dos produtos', value: 'valorProdutos' },
        { label: 'Comissão', value: 'comissao' },
        { label: 'ICMS-ST', value: 'icms' },
        { label: 'Frete', value: 'frete' },
        { label: 'Valor de repasse', value: 'valorRepasse' },
        { label: 'Status de repasse', value: 'statusRepasse' },
        { label: 'Data de repasse', value: 'dataRepasse' },
      ],
      content: filteredOrders.map(data => ({
        numeroPedido: data.order_name,
        dataPedido: formatDataEnvio(data.data_de_envio),
        statusPedido: data.status_fornecedores_portal,
        valorProdutos: formatPrice(data.sub_total),
        comissao: formatPrice(data.take_rate),
        icms: formatPrice(data.icms_st),
        frete: formatPrice(data.shipping),
        valorRepasse: formatPrice(data.total),
        statusRepasse: DicionarioStatus[data.status_finance_raw],
        dataRepasse: data.data_pagamento_fornecedor
          ? data.data_pagamento_fornecedor.split('-').reverse().join('/')
          : data.real_payment_date_format,
      })),
    },
  ];
  const settings = {
    fileName: 'Extrato-financeiro', // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
  };
  xlsx(data, settings); // Will download the excel file
};
